import { CA } from '../../shared/scripts/analytics/Analytics.ts';
import { StorageWrapper } from '../../shared/scripts/StorageWrapper.ts';
import { ClientUserState } from '../../shared/scripts/ClientUserState.ts';
import { setElementOnClick } from '../../shared/scripts/ui_utils/DomUtils.ts';
import { navigateToPage } from '../../shared/scripts/ui_utils/ClientUtils.ts';
import { PushNotificationPopupIntentEnum, UIMRequestPushNotificationController } from './notifications/UIMRequestPushNotificationController.ts';
import { clientI18n } from '../../shared/scripts/ClientI18n.ts';
import { UIAjaxWrapper } from '../../shared/scripts/network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../../shared/scripts/network/UIAPIEndpoints.ts';
import { UIUtilsEjsVariables } from '../../shared/scripts/UIUtilsEjsVariables.ts';
import { SUGGESTIONS_BOARD_URL } from '@colonist/consts';
export class UIMLoginController {
    removeLoading() {
        this.loginButtons.forEach((btn)=>{
            if (btn == null) return;
            btn.classList.remove('loading');
        });
    }
    applyNoltSsoUI() {
        var _ClientUserState_userState;
        const tagline = document.querySelector('.login-tagline');
        const features = document.querySelector('.login-features');
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn) {
            if (tagline) tagline.textContent = clientI18n.t('strings:popups.login.noltLoginSuccess');
            if (features) features.style.display = 'none';
            void UIMLoginController.replaceButtonsWithContinue();
            return;
        }
        if (tagline) tagline.textContent = clientI18n.t('strings:popups.login.noltSsoMessage');
        if (features) features.style.display = 'none';
        this.replaceGuestWithCancel();
    }
    static async replaceButtonsWithContinue() {
        const wrapper = document.querySelector('.popup-login-wrapper');
        if (!wrapper) return;
        const ssoUrl = await UIMLoginController.fetchNoltSsoUrl();
        wrapper.replaceChildren();
        const link = document.createElement('a');
        link.className = 'popup-login-btn login-btn-provider';
        link.href = ssoUrl;
        if (!UIUtilsEjsVariables.isUserOnMobileWebBrowser) {
            setElementOnClick(link, ()=>{
                navigateToPage(ssoUrl, true);
                setTimeout(()=>{
                    navigateToPage('/mobile');
                }, 100);
            });
        }
        const span = document.createElement('span');
        span.textContent = clientI18n.t('strings:popups.login.noltContinueToBoard');
        link.appendChild(span);
        wrapper.appendChild(link);
    }
    static async fetchNoltSsoUrl() {
        var _response_json;
        const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiNoltToken());
        var _response_json_noltSsoUrl;
        return (_response_json_noltSsoUrl = response === null || response === void 0 ? void 0 : (_response_json = response.json) === null || _response_json === void 0 ? void 0 : _response_json.noltSsoUrl) !== null && _response_json_noltSsoUrl !== void 0 ? _response_json_noltSsoUrl : SUGGESTIONS_BOARD_URL;
    }
    replaceGuestWithCancel() {
        if (!this.guestLogin) return;
        this.guestLogin.href = SUGGESTIONS_BOARD_URL;
        if (!UIUtilsEjsVariables.isUserOnMobileWebBrowser) {
            setElementOnClick(this.guestLogin, ()=>{
                setTimeout(()=>{
                    navigateToPage('/mobile');
                }, 100);
            });
        }
        const textSpan = this.guestLogin.querySelector('.popup-login-continue-btn-text');
        if (textSpan) textSpan.textContent = clientI18n.t('strings:colonistCommon.buttons.cancel');
    }
    handleUserLoginFlow() {
        var _ClientUserState_userState;
        const loginContainer = document.getElementById('login-container');
        if (this.isNoltSso) {
            loginContainer.style.display = '';
            return;
        }
        const shouldShowLoginScreen = !((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn) && !StorageWrapper.getIfUserBypassedLogin();
        if (shouldShowLoginScreen) {
            loginContainer.style.display = '';
            // eslint-disable-next-line no-restricted-syntax
            this.loginButtons.forEach((loginButton)=>loginButton.addEventListener('click', ()=>CA.sendGoogleTagManagerEvent(CA.GoogleTagManagerEvent.UserClickedLoginButton)));
        } else {
            loginContainer.style.display = 'none';
            UIMRequestPushNotificationController.showRequestPushNotification(PushNotificationPopupIntentEnum.OnLoadHomePage);
        }
    }
    constructor(){
        this.isNoltSso = new URLSearchParams(window.location.search).get('nolt-sso') === '1';
        this.loginButtons = Array.from(document.getElementsByClassName('popup-login-btn'));
        this.guestLogin = document.getElementById('continue-as-guest');
        this.loginButtons.forEach((btn)=>{
            if (btn == null) return;
            // eslint-disable-next-line no-restricted-syntax
            btn.addEventListener('click', ()=>{
                btn.classList.add('loading');
                setTimeout(()=>{
                    this.removeLoading();
                }, 7500);
            });
        });
        if (this.isNoltSso) {
            this.applyNoltSsoUI();
        }
        this.handleUserLoginFlow();
        if (this.guestLogin && !this.isNoltSso) {
            const bypassLogin = ()=>{
                StorageWrapper.setUserBypassedLogin(true);
                this.handleUserLoginFlow();
            };
            setElementOnClick(this.guestLogin, bypassLogin);
        }
    }
}
